var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"change-orders"},[_c('h4',[_vm._v("Change Orders")]),_c('div',{staticClass:"page-content"},[_vm._v(" Coming soon! ")])])}]

export { render, staticRenderFns }